// jQuery( document ).ready( function( $ ) {
//   // Simple accordion functionality
//   $( '.accordion__group button' ).on( 'click', function( e ) {
//     e.preventDefault(); 
//     // If item clicked on is open, close it
//     if ( $( this ).closest( '.accordion__group' ).hasClass( 'active' ) ) {
//       $( this ).closest( '.accordion__group' ).removeClass( 'active' );
//       $( this ).closest( '.accordion__group' ).find( '.accordion__copy' ).slideUp();
//     } else {
//       // Otherwise, close all others and open the one clicked on
//       $( '.accordion__group' ).removeClass( 'active' );
//       $( '.accordion__copy' ).slideUp();
//       $( this ).closest( '.accordion__group' ).addClass( 'active' );
//       $( this ).closest( '.accordion__group' ).find( '.accordion__copy' ).slideToggle();
//     }
//   } )
// // });
// jQuery( document ).ready( function( $ ) {
//   $( '.customer--addresses .add-address' ).on( 'click', function( e ) {
//     $( '#address-add' ).toggle();
//     $( '#address-list' ).toggle();
//   } );
//   $( '.customer--addresses .add-address-cancel' ).on( 'click', function( e ) {
//     $( '#address-add' ).toggle();
//     $( '#address-list' ).toggle();
//   } )
// });
// jQuery( document ).ready( function( $ ) {
//   // Simple quantity box increase / decrease
//   $( '.js-qty:not(.js-qty--cart)' ).on( 'click', function( e ) {
//     e.preventDefault();
//     var $this = $( this );
//     var $parent = $this.parent();
//     var qtyInput = $parent.find( 'input' );
//     var qtyInputVal = qtyInput.val();
//     qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
//     if ( $this.hasClass( 'js-qty--plus' ) ) {
//         qtyInputVal++;
//         qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
//     } else {
//         qtyInputVal--;
//         qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
//     }
//     qtyInput.val( qtyInputVal );
//   } );
// });
// jQuery( document ).ready( function( $ ) {
//   // Make mobile category selector go to tag page
//   $( '.blog__tags select' ).on( 'change', function() {
//     var tagUrl = $( this ).val();
//     window.location = tagUrl;
//   } )
// });
// jQuery( document ).ready( function( $ ) {
//   // PDP Options active class
//   $( '.pdp__options button' ).on( 'click', function( e ) {
//     e.preventDefault();
//     $( this ).closest( '.option__wrap' ).find( 'button' ).removeClass( 'active' );
//     $( this ).addClass( 'active' );
//   } );
// });
// jQuery( document ).ready( function( $ ) {
//   $( '.alert-bar__slider' ).slick( {
//     infinite: true,
//     slideToShow: 1,
//     vertical: true,
//     autoplay: true,
//     dots: false,
//     arrows: false,
//     autoplaySpeed: 3500,
//   } );
//   headerOffset();  
//   // Update offset on scroll
//   $(window).on( 'scroll resize', function(){
//     headerOffset();
//   });
//   // Update offset on alert bar close
//   $( '.alert-bar .close--alert' ).on( 'click', function( ) {
//     $( '.alert-bar' ).remove();
//     headerOffset();
//   } )
//   // Offset content from fixed header
//   function headerOffset() {
//     var headerHeight = $( '.fixed-wrap' ).innerHeight();
//     $( '#main' ).css( 'padding-top', headerHeight+'px' );
//     $(window).on( 'scroll resize', function(){
//       var newsHeight = $( '.fixed-wrap .alert-bar' ).innerHeight();
//       if ( $(window).scrollTop() >= 350 ) {
//         $( '.fixed-wrap' ).addClass('scrolling');
//         if ( newsHeight != undefined ) {
//           $( '.fixed-wrap' ).css( 'transform', 'translateY(-'+newsHeight+'px)' );
//         }
//        }
//        else {
//         $( '.fixed-wrap' ).removeClass('scrolling');
//         $( '.fixed-wrap' ).css( 'transform', 'translateY(0)' );
//         // $( '.mobile-menu' ).css( 'margin-top', '0' );
//         // $( '.mini-cart' ).css( 'margin-top', '0' );
//        }
//     });
//   }
// });
// jQuery( document ).ready( function( $ ) {
//   // Hero--full Slider
//   $( '.hero--full .hero__slider' ).slick({
//     fade: true,
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     centerMode: false,
//     arrows: true,
//     dots: true,
//     responsive: [
//       {
//         breakpoint: 576,
//         settings: {
//           arrows: false
//         }
//       }
//     ]
//   });
//   // Hero--split Slider
//   $( '.hero--split .hero__slider' ).slick({
//     fade: true,
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     centerMode: false,
//     arrows: true,
//     dots: true,
//     appendDots: '.hero--split .split--dots',
//     responsive: [
//       {
//         breakpoint: 576,
//         settings: {
//           arrows: false
//         }
//       }
//     ]
//   });
//   // Hero--split-flip Slider
//   $( '.hero--split-flip .hero__slider' ).slick({
//     fade: true,
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     centerMode: false,
//     arrows: true,
//     dots: true,
//     appendDots: '.hero--split-flip .split--dots',
//     responsive: [
//       {
//         breakpoint: 576,
//         settings: {
//           arrows: false
//         }
//       }
//     ]
//   });
//   // PDP Default image slider
//   $( '.pdp__images--default .pdp__slider--thumb' ).slick({
//     infinite: true,
//     arrows: true,
//     dots: false,
//     slidesToShow: 5,
//     vertical: true,
//     focusOnSelect: true,
//     asNavFor: '.pdp__images--default .pdp__slider--main',
//     responsive: [
//       {
//         breakpoint: 1280,
//         settings: {
//           slidesToShow: 4,
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 4,
//           vertical: false
//         }
//       }
//     ]
//   })
//   $( '.pdp__images--default .pdp__slider--main' ).slick({
//     infinite: true,
//     fade: true,
//     arrows: false,
//     dots: false,
//     asNavFor: '.pdp__images--default .pdp__slider--thumb'
//   })
// } );
// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 
(function ($) {})(jQuery);
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.